var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "60px",
    width: "60px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7cb54"
    },
    d: "M390.467,196.487h-99.478v270.325c0,19.324-15.665,34.989-34.989,34.989 s-34.989-15.665-34.989-34.989V196.487h-99.478c-14.309,0-25.91-11.601-25.91-25.91c0-6.872,2.73-13.462,7.589-18.322 L237.678,17.788c5.06-5.06,11.691-7.589,18.322-7.589c6.631,0,13.262,2.529,18.322,7.589l134.467,134.467 c4.859,4.859,7.589,11.45,7.589,18.322C416.377,184.886,404.777,196.487,390.467,196.487z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c3e1d"
    },
    d: "M256,512c-24.918,0-45.189-20.271-45.189-45.189V206.686h-89.279 c-19.911,0-36.109-16.198-36.109-36.109c0-9.645,3.756-18.712,10.576-25.534L230.466,10.577C237.288,3.756,246.356,0,256,0 c9.644,0,18.712,3.756,25.533,10.577L416,145.043c6.821,6.821,10.577,15.889,10.577,25.534c0,19.911-16.198,36.109-36.109,36.109 h-89.279V466.81C301.189,491.729,280.918,512,256,512z M256,20.398c-4.196,0-8.142,1.635-11.111,4.602L110.423,159.467 c-2.967,2.967-4.602,6.913-4.602,11.11c0,8.663,7.048,15.711,15.711,15.711h99.478c5.632,0,10.199,4.566,10.199,10.199V466.81 c0.001,13.67,11.122,24.791,24.791,24.791c13.669,0,24.79-11.121,24.79-24.79V196.487c0-5.633,4.567-10.199,10.199-10.199h99.478 c8.663,0,15.711-7.048,15.711-15.711c0-4.196-1.635-8.142-4.603-11.11L267.109,25C264.142,22.033,260.196,20.398,256,20.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c3e1d"
    },
    d: "M342.693,134.856c-2.611,0-5.22-0.995-7.212-2.987l-2.266-2.266c-3.983-3.983-3.983-10.441,0-14.425 c3.984-3.983,10.44-3.983,14.425,0l2.266,2.266c3.983,3.983,3.983,10.441,0,14.425C347.913,133.86,345.304,134.856,342.693,134.856 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c3e1d"
    },
    d: "M317.314,109.642c-2.611,0-5.22-0.995-7.212-2.987l-59.666-59.666 c-3.983-3.983-3.983-10.441,0-14.424c3.985-3.982,10.441-3.983,14.425,0l59.666,59.666c3.983,3.984,3.983,10.441,0,14.425 C322.534,108.647,319.923,109.642,317.314,109.642z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2cb895a118cf8c78c43a93ec7382ee8f.svg";
export { ForwardRef as ReactComponent };